export class ConfigMaxSet {
    public id: number;
    public name: String;
    public title: String;
    public vmwProductId: number;
    public vmwProductReleaseId: any;
    public publishedDate: Date;
    public statusId: number;
    public comments: String;
    public lastUpdate: Date;
    public updatedBy: String;
    public versions: any;
    public newVersion: boolean;
    public cloneProductId: number;
    public coneProductReleaseId: any;
}



// WEBPACK FOOTER //
// ./src/app/models/configmaxset.ts